/**
 * Builds the `notification_clicked` event fired when a notification row in
 * the dropdown (or the full /notifications page) is clicked and navigated
 * away from — see Alert.tsx's `linkOnClick`.
 */

import { getSessionId } from "./session";
import type { NotificationClickedEvent } from "./types";

interface NotificationClickedInput {
  notificationIds: number[];
  alertTypeId: number;
  link: string;
}

export const buildNotificationClickedEvent = ({
  notificationIds,
  alertTypeId,
  link,
}: NotificationClickedInput): NotificationClickedEvent => ({
  name: "notification_clicked",
  occurred_at: new Date().toISOString(),
  session_id: getSessionId(),
  hub_id: null,
  project_id: null,
  properties: {
    notification_ids: notificationIds,
    alert_type_id: alertTypeId,
    link,
  },
});
